import {createContext} from 'react';

import {ColorLegendContext as ColorLegendContextType} from 'src/types';
import {makeColorGetter} from 'src/state/dependency2';

const getLegendEntry = makeColorGetter(() => {});

export const ColorLegendContext = createContext<ColorLegendContextType>({
  colorLegend: {},
  getLegendEntry,
});
